/* LogSequence.js */

"use strict";

module.exports = {
    LOG_SEQUENCE: {
        NONE: {displayName: "None", value: "none"},
        LOG_EVENT_NUMBER: {displayName: "Log Event #", value: "log_event_number"},
        LINE_NUMBER: {displayName: "Line #", value: "line_number"},
        TIME_STAMP: {displayName: "Timestamp", value: "time_stamp"},
        TIME_PASSED: {displayName: "Time Passed", value: "time_passed"},
        EVENT_DURATION: {displayName: "Event Duration", value: "event_duration"},

        isValidSequence(logSequence) {
            if (this.NONE.value === logSequence) {
                return this.NONE;
            } else if (this.LOG_EVENT_NUMBER.value === logSequence) {
                return true;
            } else if (this.LINE_NUMBER.value === logSequence) {
                return true;
            } else if (this.TIME_STAMP.value === logSequence) {
                return true;
            } else if (this.TIME_PASSED.value === logSequence) {
                return true;
            } else if (this.EVENT_DURATION.value === logSequence) {
                return true;
            }
        },
    },
};
